import { render, staticRenderFns } from "./ActivityCreateForm.vue?vue&type=template&id=18645a66&"
import script from "./ActivityCreateForm.vue?vue&type=script&lang=js&"
export * from "./ActivityCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports